import { defaultColumns, defaultSort } from '../../components/docket/documentTypes/columns';

export default {
  state: {
    documentTypes: [],
    tableConfig: null,
    loading: false,
    currentPage: 1,
    filterString: null,
    sorting: {
      prop: 'name',
      order: 'ascending',
    },
  },
  getters: {
    documentTypes: state => state.documentTypes,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
  },
  mutations: {
    setDocumentTypes(state, documentTypes) {
      state.documentTypes = documentTypes;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/document-type-list');
        if (setting.id) {
          const tableConfig = {
            id: setting.id,
            type: 'document-type-list',
            columns: JSON.parse(setting.config).columns,
            sort: JSON.parse(setting.config).sort,
          };
          commit('setTableConfig', tableConfig);
        } else {
          const tableConfig = {
            type: 'document-type-list',
            columns: defaultColumns,
            sort: defaultSort,
          };
          commit('setTableConfig', tableConfig);
        }
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const documentTypes = await axios.get('api/document-types' + (query || ''));
        commit('setDocumentTypes', documentTypes);
      } catch (e) {
        console.log(e);
      }
      commit('setLoading', false);
    },

    async fetchAllWithoutPagination ({ commit }) {
      try {
        return await axios.get('api/document-types/all');
      } catch (e) {
      }
    },

    async fetch({ commit }, id) {
      return await axios.get(`api/document-types/${id}`);
    },
    async create({ commit }, payLoad) {
      await axios.post('api/document-types', payLoad);
    },
    async update({ commit }, payLoad) {
      await axios.put('api/document-types', payLoad);
    },

    async delete({ commit }, id) {
      await axios.delete('api/document-types/' + id);
    }
  },
};
